// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__mwUJR","header":"PatientQuestionnaire_header__3Gi5d","info":"PatientQuestionnaire_info__3AU-2"};